import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["largeClass", "middleClass", "smallClass"]

  connect() {
    this.originalMiddleOptions = this.getSelectOptions(this.middleClassTarget)
    this.originalSmallOptions = this.getSelectOptions(this.smallClassTarget)
  }

  getSelectOptions(selectElement) {
    return Array.from(selectElement.options).map(option => ({
      value: option.value,
      text: option.text
    }))
  }

  largeClassChanged(event) {
    const largeClassId = event.target.value

    if (!largeClassId) {
      this.resetMiddleClass()
      this.resetSmallClass()
      return
    }

    const filteredMiddleOptions = this.originalMiddleOptions.filter(option =>
      option.value === '' || option.value.startsWith(largeClassId)
    )

    const filteredSmallOptions = this.originalSmallOptions.filter(option =>
      option.value === '' || option.value.startsWith(largeClassId)
    )

    this.updateSelectWithTomSelect(this.middleClassTarget, filteredMiddleOptions, '中分類を選択してください')
    this.updateSelectWithTomSelect(this.smallClassTarget, filteredSmallOptions, '小分類を選択してください')
  }

  middleClassChanged(event) {
    const middleClassId = event.target.value

    if (!middleClassId) {
      const largeClassId = this.largeClassTarget.value
      if (largeClassId) {
        const filteredSmallOptions = this.originalSmallOptions.filter(option =>
          option.value === '' || option.value.startsWith(largeClassId)
        )
        this.updateSelectWithTomSelect(this.smallClassTarget, filteredSmallOptions, '小分類を選択してください')
      } else {
        this.resetSmallClass()
      }
      return
    }

    const filteredSmallOptions = this.originalSmallOptions.filter(option =>
      option.value === '' || option.value.startsWith(middleClassId)
    )

    this.updateSelectWithTomSelect(this.smallClassTarget, filteredSmallOptions, '小分類を選択してください')
  }

  updateSelectWithTomSelect(selectElement, options, promptText) {
    if (selectElement.tomselect) {
      selectElement.tomselect.destroy()
    }

    selectElement.innerHTML = ''
    const promptOption = document.createElement('option')
    promptOption.value = ''
    promptOption.text = promptText
    selectElement.appendChild(promptOption)

    options.filter(opt => opt.value !== '').forEach(option => {
      const optionElement = document.createElement('option')
      optionElement.value = option.value
      optionElement.text = option.text
      selectElement.appendChild(optionElement)
    })

    this.initTomSelect(selectElement)
  }

  resetMiddleClass() {
    this.updateSelectWithTomSelect(this.middleClassTarget, this.originalMiddleOptions, '中分類を選択してください')
  }

  resetSmallClass() {
    this.updateSelectWithTomSelect(this.smallClassTarget, this.originalSmallOptions, '小分類を選択してください')
  }

  initTomSelect(selectElement) {
    const TomSelect = require('tom-select').default
    new TomSelect(selectElement, {
      allowEmptyOption: false,
      create: true,
      controlInput: null,
      plugins: ['input_autogrow']
    })
  }
}
